module.exports = __webpack_public_path__ + "img/sinquanon.c683a25c.png";